var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 799,
    viewBox: "0 0 800 799",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 0.5625C280.938 0.5625 174.531 52.75 101.406 135.25L0 33.8437V300.562H266.719L172.656 206.5C227.5 141.969 308.594 100.562 400 100.562C565.781 100.562 700 234.781 700 400.562C700 566.344 565.781 700.562 400 700.562C317.188 700.562 242.187 666.969 187.812 612.75L117.188 683.375C189.688 755.719 289.688 800.562 400 800.562C620.937 800.562 800 621.5 800 400.562C800 179.625 620.937 0.5625 400 0.5625Z",
    fill: "#0084FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevertIcon);
export default __webpack_public_path__ + "static/media/revert-icon.1954d6b9aedae15e905c3bab79fa70da.svg";
export { ForwardRef as ReactComponent };